<template>
  <InteractionStep
                   :disabled-next="!showNext"
                   :pending-next="pendingSave"
                   @next="onNext">

    <template v-slot:content>
      <div class="step-check-files">
        <div class="step-check-files__list-wrap">
          <div class="step-check-files__list">
            <div v-for="(file, index) in filesInner"
                 :key="file.file.id"
                 :class="{'_approved': file.approved, '_rejected': file.rejected}"
                 class="step-check-files__item">
              <div class="step-check-files__item-file-wrap">
                <FileShow :value="file.file"
                          class="step-check-files__item-file-el"/>
              </div>
              <div class="step-check-files__item-buttons">
                <a :href="file.file.path"
                   download

                   @click.prevent="onDownload(file.file)"
                   class="base-btn step-check-files__item-btn _download"
                >
                  <span class="_one">{{ $tInteraction('Download') }}</span>
                  <BaseSvg name="ico-download-2"
                           width="1.4rem"
                           height="1.4rem"/>
                </a>
                <button v-if="!file.rejected"
                        type="button"
                        @click.prevent="onAcceptFile(index)"
                        class="base-btn step-check-files__item-btn _done"
                >
                  <BaseSvg name="ico-check"
                           width="1.3rem"
                           height=".9rem"/>
                  <span class="_one">{{ $tInteraction('Everything is correct') }}</span>
                  <span class="_more">{{ $tInteraction('Ok') }}</span>
                  <BasePreloader v-if="file.pendingAccept"/>
                </button>
                <button type="button"
                        class="base-btn step-check-files__item-btn _problem"
                        @click.prevent="onReject(index)"
                >
                  <BaseSvg name="ico-close"
                           width="1.4rem"
                           height="1.4rem"/>
                  <span>{{ $tInteraction('There is a problem') }}</span>
                </button>
              </div>
              <BaseInputError :value="createErrors(file)"
                              class="step-contract__download-file-warning  _warning"/>
            </div>
          </div>
        </div>

        <transition name="fade">
          <div v-if="showPopup"
               class="step-check-files__popup problem-popup">
            <BasePreloader v-if="pendingReject"/>
            <button type="button"
                    class="problem-popup__close"
                    @click.prevent="onClosePopup">
              <BaseSvg name="ico-close"/>
            </button>

            <div class="problem-popup__content">
              <h3 class="problem-popup__title">{{ $tInteraction('Describe the problem') }}</h3>

              <div class="problem-popup__check-wrap">
                <BaseSelect
                    :label="$tInteraction('Select from the list')"
                    v-model="inputs.reject_reasons.value"
                    :options="rejectReasons"
                    text-key="name"/>

              </div>

              <BaseInput :label="$tInteraction('Comment')"
                         v-model="inputs.reject_reasons_description.value"
                         textarea
                         rows="4"
                         class="problem-popup__input"
              />
              <BaseAlert :value="errorRejection"
                         class="problem-popup__error  _error"/>
              <button v-if="inputs.reject_reasons_description.value || inputs.reject_reasons.value"
                      type="button"
                      @click.prevent="onRejectionSubmit"
                      class="problem-popup__btn base-btn base-btn--green">
                <span>{{ $tInteraction('Send') }}</span>
              </button>
              <button v-else
                      type="button"
                      disabled
                      class="problem-popup__btn base-btn base-btn--green">
                <span>{{ $tInteraction('Send') }}</span>
              </button>
            </div>
          </div>
        </transition>
      </div>

      <div class="step-text">
        <h3 class="step-text__title">{{ $tInteraction('Insurance purchased from Jobian?') }}</h3>
        <div :class="!isAllChecked ? '_disabled' : null"
             class="step-text__options step-options">
          <div class="step-options__inner">
            <label class="step-options__item">
              <input type="radio"
                     name="type-option"
                     :value="1"
                     v-model="jobian_insurance"
                     hidden>
              <span class="step-options__item-mark">
                <BaseSvg name="ico-check"/>
              </span>
              <span class="step-options__item-inner">
                <span>{{ $tInteraction('Yes') }}</span>
              </span>
            </label>
            <label class="step-options__item">
              <input type="radio"
                     name="type-option"
                     :value="0"
                     v-model="jobian_insurance"
                     hidden>
              <span class="step-options__item-mark">
                <BaseSvg name="ico-check"/>
              </span>
              <span class="step-options__item-inner">
                <span>{{ $tInteraction('No') }}</span>
              </span>
            </label>
          </div>
        </div>

      </div>

      <BaseAlert :value="error" class="step-insurance__error  _error"/>
    </template>

  </InteractionStep>
</template>

<script>
  import {mapState} from 'vuex'
  import InteractionStep from '../InteractionStep'
  import BaseInputError from '../../BaseInputError'
  import FileShow from '../../FileShow'
  import windowSizeMixin from '../../../mixins/windowSizeMixin'
  import {blockScroll, unBlockScroll} from '../../../helpers/scroll'
  import {http} from "../../../axios"
  import download from "../../../helpers/download"
  import {IMAGES_MIME_TYPES, ALLOWED_IMAGES_EXTS} from '../../../constants/files'
  import interactionStepMixin from "@/mixins/interactionStepMixin"


  export default {
    name: 'InteractionStepVisa',
    components: {
      InteractionStep,
      BaseInputError,
      FileShow,
    },
    mixins: [windowSizeMixin, interactionStepMixin],
    data() {
      return {
        showPopup: false,
        fileToRejectIndex: null,
        timer: null,
        pendingSave: false,
        pendingReject: false,
        error: null,
        errorRejection: null,
        inputs: {
          reject_reasons: {
            value: null
          },
          reject_reasons_description: {
            value: null
          }
        },
        filesInner: [],
        jobian_insurance: null
      }
    },
    computed: {
      ...mapState('interaction', [
        'step',
        'rejectReasons',
      ]),
      files() {
        return this.$store.state.interaction.stepData.data.map(file => {
          file.rejected = file.reject_reasons_description || file.reject_reasons
          return file
        })
      },
      isAllChecked() {
        return !this.filesInner.some(file => !file.approved && !file.rejected)
      },
      showNext() {
        if (this.jobian_insurance === null) return false

        return this.isAllChecked
      }
    },
    methods: {
      onNext() {
        const file = this.filesInner.find(file => file.approved)

        const sendData = {
          file_id: file.file.id,
          approved: 1,
          jobian_insurance: this.jobian_insurance
        }

        this.error = null
        this.pendingSave = true

        http.post(`/api/new-interaction/${this.$route.params.id}/${this.step}`, sendData).then(async () => {
          await this.$store.dispatch('interaction/loadInteraction')
        }).catch(e => {
          this.handleInteractionError(e)
        }).finally(() => {
          this.pendingSave = false
        })
      },
      onAcceptFile(index) {
        const file = this.filesInner[index]
        this.$set(file, 'approved', true)
      },
      onReject(index) {
        this.onShowPopup()
        this.fileToRejectIndex = index
      },
      onRejectionSubmit() {
        this.errorRejection = null

        const file = this.filesInner[this.fileToRejectIndex]
        const sendData = {
          file_id: file.file.id,
          approved: 0,
          reject_reasons: this.inputs.reject_reasons.value ? this.inputs.reject_reasons.value.id : null,
          reject_reasons_description: this.inputs.reject_reasons_description.value,
        }

        this.pendingReject = true

        http.post(`/api/new-interaction/${this.$route.params.id}/${this.step}`, sendData).then(async () => {
          await this.$store.dispatch('interaction/loadInteraction')
        }).catch(e => {
          this.errorRejection = this.handleInteractionError(e, false)
        }).finally(() => {
          this.pendingReject = false
        })
      },
      onShowPopup() {
        if (this.windowSizeMixin.width < 768) {
          blockScroll()
        }

        this.errorRejection = null
        this.showPopup = true
      },
      onClosePopup() {
        unBlockScroll()
        this.showPopup = false
      },
      checkMob() {
        clearTimeout(this.timer)
        this.timer = setTimeout(() => {
          if (this.showPopup && this.windowSizeMixin.width > 767) {
            this.onClosePopup()
          }
        }, 200)
      },
      isFileImg(file) {
        if (file.type) {
          return IMAGES_MIME_TYPES.includes(file.type)
        } else {
          return ALLOWED_IMAGES_EXTS.includes(file.ext)
        }
      },
      onDownload(file) {
        download(file.path, file.name_for_download || file.name, file.name_for_download ? null : file.ext)
      },
      createErrors(file) {
        const a = []
        if (file.reject_reasons) a.push(file.reject_reasons.name)
        if (file.reject_reasons_description) a.push(file.reject_reasons_description)

        return a
      },
    },
    watch: {
      files(files) {
        this.filesInner = files
      }
    },
    created() {
      this.filesInner = this.files
    },
    mounted() {
      window.addEventListener('resize', this.checkMob)
    },
    beforeDestroy() {
      this.onClosePopup()
      window.removeEventListener('resize', this.checkMob)
    }
  }
</script>

<style>

</style>
